import React from 'react';
import { useAuth } from '../../auth/useAuth';
import { Button } from '../../components/Common/button';
import { useAuthStore } from '../../stores/authStore';
import { useTranslation } from 'react-i18next';

const OrganizationDeactivatedPage: React.FC = () => {
  const { signOut } = useAuth();
  const logout = useAuthStore((state) => state.actions.logout);
  const { t } = useTranslation();

  const handleLogout = async () => {
    try {
      logout();
      await signOut(window.location.origin);
    } catch (error) {
      console.error('Error during logout:', error);
      logout();
      window.location.href = window.location.origin;
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <div className="max-w-md w-full text-center px-6">
        <h1 className="text-2xl font-semibold mb-2">{t('organizationDeactivated.title')}</h1>
        <p className="text-muted-foreground mb-6">{t('organizationDeactivated.description')}</p>
        <Button
          variant="destructive"
          onClick={handleLogout}
          className="w-full sm:w-auto"
        >
          {t('organizationDeactivated.logout')}
        </Button>
      </div>
    </div>
  );
};

export default OrganizationDeactivatedPage;
